'use strict'

module.exports = normalize

function normalize(value) {
  return value.toLowerCase().replace(/\b[:-]\b/g, '')
}



//////////////////
// WEBPACK FOOTER
// ./~/hast-to-hyperscript/~/property-information/normalize.js
// module id = 266
// module chunks = 131683993344931